const {WindowDataConfiguration} = require("./configuration/window-data-configuration");
const {PreviewTab} = require("../preview-tab/preview-tab");

const WindowDataStepPanelTabs = {
    configuration: WindowDataConfiguration,
    preview: PreviewTab,
};
exports.WindowDataStepPanelTabs = WindowDataStepPanelTabs;
